import { forecast } from './filter-actions.forecast';
export var process = function (groups, filters) {
    if (groups === void 0) { groups = []; }
    if (filters === void 0) { filters = []; }
    var forecastedFilters = forecast(groups, filters);
    filters.forEach(function (filter, filterIndex) {
        filter.options.forEach(function (option, optionIndex) {
            option.disabled = forecastedFilters[filterIndex].options[optionIndex].disabled;
        });
    });
};
